import { createFileRoute } from "@tanstack/react-router";

import { GithubFormPage } from "~/pages/connection-new/github-form.page";

export const Route = createFileRoute(
  "/_app/settings/_organization/connections/new/_connection/github",
)({
  component: GithubFormPage,
});
